<template>
    <div id="storyhandler">
        <div class="story-wrapper">
            <div class="flex-wrapper">


                <button class="btn" @click="showIntro">
                    <svg width="12px" height="11px" viewBox="0 0 12 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Artboard" transform="translate(-533.000000, -80.000000)" stroke="#000000" stroke-width="1.4">
                                <g id="Group-Copy" transform="translate(534.000000, 80.000000)">
                                    <path d="M0,1.05 L10.85,0.875" id="Line-Copy-2"></path>
                                    <path d="M0,5.1625 L10.85,4.9875" id="Line-Copy-3"></path>
                                    <path d="M0,9.3625 L10.85,9.1875" id="Line-Copy-4"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    Start
                </button>

                <div>

                    <button style="margin-right: 7px;" class="btn" @click="togglePreviousStory">

                        <svg width="8px" height="13px" viewBox="0 0 8 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Artboard" transform="translate(-693.000000, -79.000000)" stroke="#000000" stroke-width="2">
                                    <polyline id="Path-Copy" transform="translate(697.500000, 85.500000) rotate(-90.000000) translate(-697.500000, -85.500000) " points="692 88 697.708827 83 703 88"></polyline>
                                </g>
                            </g>
                        </svg>
                    </button>

                    <button class="btn" @click="toggleNextStory">
                        <svg width="8px" height="13px" viewBox="0 0 8 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Artboard" transform="translate(-726.000000, -79.000000)" stroke="#000000" stroke-width="2">
                                    <polyline id="Path" transform="translate(729.500000, 85.500000) rotate(-270.000000) translate(-729.500000, -85.500000) " points="724 88 729.708827 83 735 88"></polyline>
                                </g>
                            </g>
                        </svg>
                    </button>

                </div>


            </div>
            <div class="storyhandler-inner" style="margin-bottom: 10px;">

                <span class="story-label">No. {{storyActive + 1}} of {{ storyCount }}</span>
                <h4>{{ this.content.stories[this.storyActive].introduction.title }}</h4>
                

            </div>
        </div>
        <!-- <div style="margin-top: 30px;" class="story-wrapper">
            Active snippet:
            <span>{{snippetCurrent + 1}} of {{ snippetCount }}</span>
            <div>
                <button class="btn prevStory mr-m" @click="togglePreviousSnippet">Previous</button>
                <button class="btn nextStory" @click="toggleNextSnippet">Next</button>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { select as d3Select } from 'd3';
    import { setTimeout } from 'timers';

    export default {
        name: 'Storyhandler',
        props: ['content'],
        data() {
            return {
                snippetAvailable: false
            }
        },
        computed: {
            ...mapState(['storyActive', 'storyCount', 'snippetCurrent', 'snippetCount', 'paragraphActive', 'visRendered', ]),
            maxIndex() {
                return this.storyCount - 1;
            },
            maxIndexSnippets() {
                return this.snippetCount - 1;
            },
            snippetEmpty() {
                const titleEmpty = this.content.stories[this.storyActive].snippets[this.snippetCurrent].title.length == 0;
                const textEmpty = this.content.stories[this.storyActive].snippets[this.snippetCurrent].text.length == 0;
                return titleEmpty && textEmpty ? true : false;
            }
        },
        watch: {
            paragraphActive() {
                let id = Number(this.paragraphActive);
                this.dispatchCurrentSnippet(id);
            },
            storyActive() {
                this.dispatchPopupActive(false);
            },
            snippetCurrent() {
                this.dispatchPopupActive(false);


                setTimeout(() => {
                    if (this.snippetEmpty && !this.visRendered) {
                        this.dispatchPopupActive(false);
                    } else if (this.snippetEmpty) {
                        this.dispatchPopupActive(false);
                    } else if (!this.snippetEmpty && this.visRendered) {
                        this.dispatchPopupActive(true);
                    }
                },100)
            },
            visRendered() {
                this.dispatchPopupActive(false);
                
                setTimeout(() => {
                    if (!this.snippetEmpty && this.visRendered) {
                        this.dispatchPopupActive(true);
                    }
                },100)

            }
        },
        methods: {
            async dispatchSetParagraphActive(id) {
                this.$store.dispatch("SET_PARAGRAPH_ACTIVE", id);
            },
            dispatchClustering(state) {
                this.$store.dispatch("SET_CLUSTERING", state);
            },
            async showIntro() {
                await this.dispatchSetParagraphActive('0')
                await this.dispatchCurrentSnippet('0');
                await this.setSidebarToTop();
                await this.dispatchPopupActive(false);
                await this.dispatchIntroVisible()
            },
            async dispatchIntroVisible() {
                this.$store.dispatch('SET_INTRO_VISIBLE', true);
            },
            dispatchCurrentStory(state) {
                this.$store.dispatch("SET_CURRENT_STORY", state);
            },
            async dispatchPopupActive(state) {
                this.$store.dispatch("SET_POPUP_ACTIVE", state);
            },
            async dispatchCurrentStory(state) {
                this.$store.dispatch("SET_CURRENT_STORY", state);
            },
            async dispatchCurrentSnippet(state) {
                this.$store.dispatch("SET_SNIPPET_CURRENT", state);
            },
            async setSidebarToTop() {
                const sidebar = d3Select('#story-sidebar-bottom').node();
                if (sidebar != null) {
                    sidebar.scrollTop = 0;
                }
            },
            async toggleNextStory() {
                await this.dispatchSetParagraphActive('0')
                await this.dispatchCurrentSnippet('0');
                await this.setSidebarToTop();
                this.dispatchPopupActive(false);
                let currentId = this.storyActive;
                let nextId = currentId == this.maxIndex ? 0 : currentId+1;
                await this.dispatchCurrentStory(nextId);
            },
            async togglePreviousStory() {
                await this.dispatchSetParagraphActive('0')
                await this.dispatchCurrentSnippet('0');
                await this.setSidebarToTop();
                this.dispatchPopupActive(false);
                let currentId = this.storyActive;
                let nextId = currentId == 0 ? this.maxIndex : currentId-1;
                await this.dispatchCurrentStory(nextId);
            },
            async toggleNextSnippet() {
                this.dispatchPopupActive(false);
                this.disableButtons()
                let currentId = this.snippetCurrent;
                let nextId = currentId == this.maxIndexSnippets ? 0 : currentId+1;
                await this.dispatchCurrentSnippet(nextId);
            },
            async togglePreviousSnippet() {
                this.dispatchPopupActive(false);
                this.disableButtons()
                let currentId = this.snippetCurrent;
                let nextId = currentId == 0 ? this.maxIndexSnippets : currentId-1;
                await this.dispatchCurrentSnippet(nextId);
            },
            disableButtons() {
                // d3Select('.nextStory').node().disabled = true
                // d3Select('.prevStory').node().disabled = true
            }
        },
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';
    #storyhandler {

        width: 290px;
        margin-left: 15px;
        margin-top: 15px;
        overflow: hidden;

        h4 {
            margin-bottom: 0;
        }

        @media screen and (max-width: 320px) {
            width: 270px;
        }

        // @media screen and (max-width: 380px) {
        //     width: 240px;
        // }

        .btn {
            border: none;
            border-radius: 4px;
            font-size: $font-size-m;
            background: #eeeeee;
            cursor: pointer;
            padding: 5px 8px;
            transition: all $time-xs ease;
            font-weight: bold;

            svg {
                transform: translateY(1px);
                g {
                    g {
                        stroke: black;
                    }
                }
            }

            &:hover {
                background: #d4d4d4;
                color: black;
                transition: all $time-xs ease;

                            svg {
                g {
                    g {
                        stroke: black;
                    }
                }
            }
            }

            &:focus {
                outline: none;
            }
        }

        .mr-m {
            margin-right: 15px;
        }

        .story-counter {
            width: 80px;
        }

        .h-line {
            width: 78%;
            background: black;
            border: none;
            height: 1px;
            transform: translateY(2px);
        }

        .flex-wrapper {
            display: flex;
            margin-bottom: 10px;    
            flex-direction: row;
            justify-content: space-between;
        }

        .story-label {
            font-size: 12px;
        }

        .storyhandler-inner {
            h4 {
                font-size: 20px;
                margin-top: 0;
            }
        }


        .story-wrapper {
            display: flex;
            flex-direction: column;
            overflow: auto;
        }
    }
</style>


